import type {
  ProyectosPropios,
  ActuacionesPropias,
  TransaccionesPropias,
} from "@/types/models/propios";

function getRelationId(value: unknown): number | null {
  if (value == null) return null;

  if (typeof value === "number") return value;

  if (typeof value === "string" && value.trim()) {
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  }

  if (typeof value === "object" && "id" in value) {
    return getRelationId((value as { id?: unknown }).id);
  }

  return null;
}

export function mapProyectosPropiosWithRelations(params: {
  proyectos: ProyectosPropios[];
  actuaciones: ActuacionesPropias[];
  transacciones: TransaccionesPropias[];
}): ProyectosPropios[] {
  const { proyectos, actuaciones, transacciones } = params;

  return proyectos.map((proyecto) => {
    const proyectoId = Number(proyecto.id);

    const proyectoActuaciones = actuaciones
      .filter(
        (actuacion) =>
          getRelationId(actuacion.proyecto_propio) === proyectoId
      )
      .map((actuacion) => {
        const actuacionId = Number(actuacion.id);

        const actuacionTransacciones = transacciones
          .filter(
            (transaccion) =>
              getRelationId(transaccion.actuacion) === actuacionId
          )
          .map((transaccion) => ({
            ...transaccion,
            actuacion,
          }));

        return {
          ...actuacion,
          transacciones: actuacionTransacciones,
        };
      });

    return {
      ...proyecto,
      actuaciones_propias: proyectoActuaciones,
    };
  });
}